import React, { useEffect } from "react";
import CuentaRegresiva from "./CuentaRegresiva";
import Versiculo from "./Versiculo";
import Galeria from "./Galeria";
import Galeria2 from "./Galeria2";

import Itinerario from "./Itinerario";
import DressCode from "./DressCode";
import LunaDeMiel from "./LunaDeMiel";
import ConfirmarAsistenciaExtra from "./ConfirmarAsistenciaExtra";
import InstagramHashtag from "./InstagramHashtag";
import Footer from "./Footer";
import Bienvenida from "./Bienvenida";
import BotonMusica from "./BotonMusica";

import "./Home.css";

export default function Home() {
  useEffect(() => {
    const secciones = document.querySelectorAll(".seccion-animada");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 } // se activa cuando el 10% de la sección es visible
    );

    secciones.forEach((sec) => observer.observe(sec));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="home-container">

      <div className="home-content">
        <div className="seccion-animada"><Bienvenida /></div>
        <div className="seccion-animada"><CuentaRegresiva /></div>
        <div className="seccion-animada"><Versiculo /></div>
        <div className="seccion-animada"><Galeria /></div>
        <div className="seccion-animada"><Itinerario /></div>
        <div className="seccion-animada"><DressCode /></div>
        <div className="seccion-animada"><Galeria2 /></div>
        <div className="seccion-animada"><LunaDeMiel /></div>
        <div className="seccion-animada"><InstagramHashtag /></div>
        <div className="seccion-animada"><ConfirmarAsistenciaExtra /></div>

        <Footer />

        {/* Botón de música no animado */}
        <BotonMusica />
      </div>
    </div>
  );
}
